import React from 'react';
import ClassAssembly  from 'views/ClassAssembly1A';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;